import React, { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode'; // Fix import (it should not be destructured)
import axios from 'axios';
import API_BASE_URL from '../../ApiConfig/ApiConfig';
import Cookies from "js-cookie";
const  AWR_Records_Customer = () => {
  const [repairDetails, setRepairDetails] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRepairDetails = async () => {
      try {
        const token = Cookies.get('token');
        if (token) {
          const decodedToken = jwtDecode(token);
          const customerId = decodedToken.customerId;

          const response = await axios.get(`${API_BASE_URL}/awr/customer/${customerId}`,
            { headers: { "Content-Type": "application/json" ,
              "Authorization": token ? `Bearer ${token}` : "",
            } });

          if (response.data.length === 0) {
            setRepairDetails([]); // No records found
          } else {
            // Sort by the latest status date
            const sortedRepairDetails = response.data.sort((a, b) => {
              const aLatestDate = a.statusUpdates[a.statusUpdates.length - 1]?.date || 0;
              const bLatestDate = b.statusUpdates[b.statusUpdates.length - 1]?.date || 0;
              return new Date(bLatestDate) - new Date(aLatestDate);
            });

            setRepairDetails(sortedRepairDetails); // Set fetched data
          }
        } else {
          setRepairDetails([]); // No token found
        }
      } catch (err) {
        console.error('Error fetching repair details:', err);
        setRepairDetails([]);
      } finally {
        setLoading(false);
      }
    };


    fetchRepairDetails();
  }, []);

  if (loading) return <p>Loading...</p>;

  // Helper function to make the status clickable if it's a URL
  const makeLinksClickable = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.split(urlRegex).map((part, index) => {
      if (urlRegex.test(part)) {
        return (
          <a key={index} href={part} target="_blank" rel="noopener noreferrer" className="text-blue-500 underline">
            {part}
          </a>
        );
      }
      return part;
    });
  };

  return (
    <div
    className="min-w-full mx-auto bg-white rounded-2xl shadow-md overflow-hidden md:mt-20"
    style={{ boxShadow: '0px 10px 60px 0px #E2ECF980' }}
  >
    {/* Heading Section (Always Visible) */}
    <div className="p-4">
      <h1 className="text-xl md:text-2xl font-bold text-gray-700 mb-2">Advance Warranty Replacement Details</h1>
    </div>
  
    {repairDetails.length === 0 ? (
      <p className="text-center text-gray-500 my-10 md:my-20">No repair details available.</p>
    ) : (
      <>
        {/* Desktop Table */}
        <div className="overflow-x-auto">
          <table className="w-full bg-white rounded-md border-collapse hidden md:table">
            <thead className="bg-[#1C50A3] text-[#FFFFFF]">
              <tr>
                <th className="py-3 px-6 border-b border-gray-300 font-semibold text-left">Product Name</th>
                <th className="py-3 px-6 border-b border-gray-300 font-semibold text-left">Product ID</th>
                <th className="py-3 px-6 border-b border-gray-300 font-semibold text-left">Purchased From</th>
                <th className="py-3 px-6 border-b border-gray-300 font-semibold text-left">Ticket Number</th>
                <th className="py-3 px-6 border-b border-gray-300 font-semibold text-left">Status Date</th>
                <th className="py-3 px-6 border-b border-gray-300 font-semibold text-left">Status</th>
              </tr>
            </thead>
  
            <tbody>
              {repairDetails.map((repair) => (
                <tr key={repair._id || 'default'} className="hover:bg-gray-100 transition">
                  <td className="py-3 px-6 border-b border-gray-300 text-left text-gray-600 text-[14px] font-semibold">
                    {repair.productDetails?.productName || 'N/A'}
                  </td>
                  <td className="py-3 px-6 border-b border-gray-300 text-left text-gray-600 text-[14px] font-semibold">
                    {repair.productId}
                  </td>
                  <td className="py-3 px-6 border-b border-gray-300 text-left text-gray-600 text-[14px] font-semibold">
                    {repair.purchaseFrom}
                  </td>
                  <td className="py-3 px-6 border-b border-gray-300 text-left text-gray-600 text-[14px] font-semibold">
                    {repair.ticketNumber}
                  </td>
                  <td className="py-3 px-6 border-b border-gray-300 text-left text-gray-600 text-[14px] font-semibold">
                    {repair.statusUpdates[repair.statusUpdates.length - 1]?.date
                      ? new Date(repair.statusUpdates[repair.statusUpdates.length - 1]?.date).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })
                      : 'N/A'}
                  </td>
                  <td className="py-3 px-6 border-b border-gray-300 text-left">
                    {(() => {
                      const currentStatus = repair.statusUpdates[repair.statusUpdates.length - 1]?.status || "N/A";
                      let statusStyle = "bg-red-100 text-red-600"; // Default (Other)
                      if (currentStatus === "Under Process") {
                        statusStyle = "bg-blue-100 text-blue-600"; // Blue for Under process
                      } else if (currentStatus === "Completed") {
                        statusStyle = "bg-green-100 text-green-600"; // Green for Completed
                      } else if (currentStatus === "On Hold") {
                        statusStyle = "bg-yellow-100 text-yellow-600"; // Yellow for On hold
                      }
  
                      return (
                        <span className={`px-3 py-1 rounded-full text-[14px] font-medium ${statusStyle}`}>
                          {currentStatus}
                        </span>
                      );
                    })()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
  
        {/* Mobile Table */}
        <div className="md:hidden">
          {repairDetails.map((repair) => (
            <div
              key={repair._id || 'default'}
              className="p-4 border-b hover:bg-gray-100 transition"
            >
              <div className="flex justify-between items-center">
                <span className="text-gray-700 font-semibold">Product Name</span>
                <span className="text-gray-600">{repair.productDetails?.productName || 'N/A'}</span>
              </div>
              <div className="flex justify-between items-center mt-2">
                <span className="text-gray-700 font-semibold">Product ID</span>
                <span className="text-gray-600">{repair.productId}</span>
              </div>
              <div className="flex justify-between items-center mt-2">
                <span className="text-gray-700 font-semibold">Ticket Number</span>
                <span className="text-gray-600">{repair.ticketNumber}</span>
              </div>
              <div className="flex justify-between items-center mt-2">
                <span className="text-gray-700 font-semibold">Status Date</span>
                <span className="text-gray-600">
                  {repair.statusUpdates[repair.statusUpdates.length - 1]?.date
                    ? new Date(repair.statusUpdates[repair.statusUpdates.length - 1]?.date).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })
                    : 'N/A'}
                </span>
              </div>
              <div className="flex justify-between items-center mt-2">
                <span className="text-gray-700 font-semibold">Status</span>
                {(() => {
                  const currentStatus = repair.statusUpdates[repair.statusUpdates.length - 1]?.status || "N/A";
                  let statusStyle = "bg-red-100 text-red-600"; // Default (Other)
                  if (currentStatus === "Under Process") {
                    statusStyle = "bg-blue-100 text-blue-600"; // Blue for Under process
                  } else if (currentStatus === "Completed") {
                    statusStyle = "bg-green-100 text-green-600"; // Green for Completed
                  } else if (currentStatus === "On Hold") {
                    statusStyle = "bg-yellow-100 text-yellow-600"; // Yellow for On hold
                  }
  
                  return (
                    <span className={`px-3 py-1 rounded-full text-[14px] font-medium ${statusStyle}`}>
                      {currentStatus}
                    </span>
                  );
                })()}
              </div>
            </div>
          ))}
        </div>
      </>
    )}
  </div>

  );
};

export default  AWR_Records_Customer;
